import { Card } from './primitives';

import type { ReactNode } from 'react';

/** Empty-state for screens whose real implementation lands in a later phase. */
export function ComingSoonPanel({
    icon,
    title,
    blurb,
}: {
    icon?: ReactNode;
    title: string;
    blurb: string;
}) {
    return (
        <Card>
            <div className="flex flex-col items-center gap-3 px-6 py-16 text-center">
                {icon && (
                    <div className="flex size-12 items-center justify-center rounded-xl bg-accent-surface text-accent-icon">
                        {icon}
                    </div>
                )}
                <div className="text-base font-semibold text-content">{title}</div>
                <p className="max-w-md text-sm text-content-muted">{blurb}</p>
                <span className="mt-1 rounded-full border border-line bg-surface-sunken px-3 py-1 text-xs font-semibold text-content-muted">
                    Coming soon
                </span>
            </div>
        </Card>
    );
}
